export function removeInterstitial() {
  const iframe = document.getElementById('di_iframe');
  if (iframe && typeof iframe.remove === 'function') {
    iframe.remove();
  }
}
export function showInterstitial() {
  const iframe = document.getElementById('di_iframe');
  if (iframe && iframe.style) {
    iframe.style.display = 'block';
  }
}

export function loadInterstitialMobileAttachEvents() {
  // window.addEventListener('message', e => {
  //   if (
  //     (e.origin.indexOf('indiatimes.com') > -1 ||
  //       e.origin.indexOf('timesofindia.com') > -1) &&
  //     typeof e.data === 'string' &&
  //     ['showinterstial', 'removeinterstial'].indexOf(e.data.toLowerCase()) > -1
  //   ) {
  //     switch (e.data.toLowerCase()) {
  //       case 'showinterstial': {
  //         if (
  //           !(
  //             window.location.href.indexOf('order_id') > -1 &&
  //             localStorage.getItem('toi_subscription')
  //           )
  //         ) {
  //           showInterstitial();
  //         }
  //         break;
  //       }
  //       case 'removeinterstial':
  //         removeInterstitial();
  //         break;
  //       default:
  //         break;
  //     }
  //   }
  // });
  // appendScriptToHead({
  //   scriptUrl: getMobDefaultInterstitialDomain(),
  // });
}
